import { useState } from "react";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import ListItemIcon from "@mui/material/ListItemIcon";
import BarChartIcon from '@mui/icons-material/BarChart';
import HomeIcon from "@mui/icons-material/Home";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CasinoIcon from '@mui/icons-material/Casino';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import SearchIcon from '@mui/icons-material/Search';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import CollectionsIcon from '@mui/icons-material/Collections';
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";






import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import {
    selectIsStaffUser,
    selectIsOfficeStaffUser,
    selectCurrentUser
} from "../../store/user/user.selector";



const DrawerPage = ({ toggleDrawer, open }) => {
    const isStaff = useSelector(selectIsStaffUser);
    const isOfficeStarff = useSelector(selectIsOfficeStaffUser);
    const user = useSelector(selectCurrentUser);
    const navigate = useNavigate();

    const handlerNavigate = (navTo) => {
        navigate(navTo);
    };

    const candidatureAllowedEmails = [
        "financeiro@pitayajoias.com.br",
        "patamarcelo@gmail.com"
    ];

    const canAccessCandidatures =
        candidatureAllowedEmails.includes(
            user?.email?.toLowerCase()
        );

    const navDict = [
        { label: 'Home', icon: <HomeIcon />, navTo: '/', isStaff: isStaff || isOfficeStarff },
        { label: 'Produtos', icon: <Inventory2OutlinedIcon />, navTo: '/produtos', isStaff: isStaff || isOfficeStarff },
        { label: 'Vendedoras', icon: <AccountCircleOutlinedIcon />, navTo: '/vendedoras', isStaff: isStaff || isOfficeStarff }

    ]
    const staffNavDict = [
        { label: 'Vendas', icon: <BarChartIcon />, navTo: '/admin', isStaff: isStaff },
        { label: 'Notas Fiscais', icon: <BarChartIcon />, navTo: '/notas-fiscais', isStaff: isStaff },
        { label: 'Acertos Futuros', icon: <CurrencyExchangeIcon />, navTo: '/acertos-futuros', isStaff: isStaff },
        { label: 'Produtos Maletas', icon: <ProductionQuantityLimitsIcon />, navTo: '/produtos-maletas', isStaff: isStaff || isOfficeStarff },
        { label: 'Ajustes Preços', icon: <AttachMoneyIcon />, navTo: '/ajustes-preco', isStaff: isStaff },
        { label: 'Ranking', icon: <EmojiEventsOutlinedIcon />, navTo: '/ranking-sellers', isStaff: isStaff },
    ]

    const inventaryNavDict = [
        { label: 'Bipando em Sequência', icon: <SearchIcon />, navTo: '/pesquisa-produtos', isStaff: isStaff || isOfficeStarff },
        { label: 'Movimentação', icon: <SyncAltIcon />, navTo: '/ajustes-estoque', isStaff: isStaff || isOfficeStarff },
    ]

    const otherNavDict = [
        { label: "Sorteios", icon: <CasinoIcon />, navTo: '/sorteios', isStaff: isStaff },
        { label: 'Etiquetas', icon: <QrCodeScannerIcon />, navTo: '/etiquetas', isStaff: isStaff },
        { label: 'Produtos Vendidos', icon: <ProductionQuantityLimitsIcon />, navTo: '/produtos-vendidos', isStaff: isStaff },
        { label: 'Produtos Personalizados', icon: <DesignServicesIcon />, navTo: '/produtos-personalizados', isStaff: isStaff },
        { label: 'Gerencial - Personalizados', icon: <AssignmentTurnedInIcon />, navTo: '/personalizados-gerencial', isStaff: isStaff },
        { label: 'Posição Estoque', icon: <Inventory2Icon />, navTo: '/posicao-estoques', isStaff: isStaff },
        { label: 'Garantias', icon: <VerifiedUserIcon />, navTo: '/garantias', isStaff: isStaff || isOfficeStarff },
        { label: 'Imagens', icon: <CollectionsIcon />, navTo: '/upload-imgs', isStaff: isStaff || isOfficeStarff },
        {
            label: "Candidaturas",
            icon: <AssignmentIndOutlinedIcon />,
            navTo: "/candidaturas",
            isStaff: canAccessCandidatures
        },
        // { label: 'Gerencial Vanessa', icon: <SupervisorAccountIcon />, navTo: '/gerencial-vanessa', isStaff: isStaff },

    ]

    const DrawerList = (
        <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
            <List>
                {navDict
                    .filter((data) => data.isStaff === undefined || data.isStaff) // Filter out items if `isStaff` is false
                    .map((data, index) => (
                        <ListItem key={index} disablePadding onClick={() => handlerNavigate(data.navTo)}>
                            <ListItemButton>
                                <ListItemIcon>{data.icon}</ListItemIcon>
                                <ListItemText primary={data.label} />
                            </ListItemButton>
                        </ListItem>
                    ))}
            </List>
            {
                inventaryNavDict.filter(item => item.isStaff).length > 0 && (
                    <>
                        <Divider>
                            <Typography variant="subtitle1" color="white" fontWeight={"bold"}>
                                Estoque
                            </Typography>
                        </Divider>
                        <List>
                            {inventaryNavDict
                                .filter(item => item.isStaff)
                                .sort((a, b) => a.label.localeCompare(b.label))
                                .map((data, index) => (
                                    <ListItem key={index} disablePadding onClick={() => handlerNavigate(data.navTo)}>
                                        <ListItemButton>
                                            <ListItemIcon>{data.icon}</ListItemIcon>
                                            <ListItemText primary={data.label} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                        </List>
                    </>
                )
            }
            {
                staffNavDict.filter(item => item.isStaff).length > 0 && (
                    <>
                        <Divider>
                            <Typography variant="subtitle1" color="white" fontWeight={"bold"}>
                                Financeiro
                            </Typography>
                        </Divider>
                        <List>
                            {staffNavDict
                                .filter(item => item.isStaff)
                                .sort((a, b) => a.label.localeCompare(b.label))
                                .map((data, index) => (
                                    <ListItem key={index} disablePadding onClick={() => handlerNavigate(data.navTo)}>
                                        <ListItemButton>
                                            <ListItemIcon>{data.icon}</ListItemIcon>
                                            <ListItemText primary={data.label} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                        </List>
                    </>
                )
            }
            {
                otherNavDict.filter(item => item.isStaff).length > 0 && (
                    <>
                        <Divider>
                            <Typography variant="subtitle1" color="white" fontWeight={"bold"}>
                                Outros
                            </Typography>
                        </Divider>
                        <List>
                            {otherNavDict
                                .filter(item => item.isStaff)
                                .sort((a, b) => a.label.localeCompare(b.label))
                                .map((data, index) => (
                                    <ListItem key={index} disablePadding onClick={() => handlerNavigate(data.navTo)}>
                                        <ListItemButton>
                                            <ListItemIcon>{data.icon}</ListItemIcon>
                                            <ListItemText primary={data.label} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                        </List>
                    </>
                )
            }
        </Box>
    );

    return (
        <div>
            <Drawer open={open} onClose={toggleDrawer(false)}>
                {DrawerList}
            </Drawer>
        </div>
    );
}

export default DrawerPage